import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_PIPELINE_FUNNEL_ACTION_TYPE = createNamedActions(
  'commandCenterPipelineFunnel',
  {
    SET_PIPELINE_FUNNEL: 'SET_PIPELINE_FUNNEL',
  },
);

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterPipelineFunnelAction = catchAsyncActionError(() => async dispatch => {
  try {
    const data = await fetchSafe(() =>
      commandCenterLoansApi.getPipelineFunnel({ config: SKIP_FORBIDDEN_CONFIG }),
    );

    dispatch({
      type: COMMAND_CENTER_PIPELINE_FUNNEL_ACTION_TYPE.SET_PIPELINE_FUNNEL,
      payload: data,
    });
  } finally {
    // In a `finally` so the slice is marked loaded even when a swallowed 403
    // degrades to null — otherwise the zone skeleton never clears.
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.PIPELINE_FUNNEL));
  }
});
